import { motion } from "framer-motion";

export const Vision = () => {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative bg-[#F2EFEB] py-24 md:py-40 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-12 items-center">
        {/* Large image with overlapping text */}
        <div className="col-span-12 md:col-span-7 order-2 md:order-1 relative">
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.3 }}
            className="relative overflow-hidden aspect-square w-full bg-black"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_vision-driven/artifacts/1u79xhay_image.png"
              alt="A father and daughter walking from a dark city toward a bright horizon — a metaphor for emotionally present fatherhood"
              className="absolute inset-0 w-full h-full object-contain"
            />
          </motion.div>

          {/* Floating quote card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.3 }}
            className="hidden md:block absolute right-4 lg:-right-8 -bottom-6 z-10 max-w-[300px] bg-[#F9F8F6] p-7 border-l-2 border-[#C06E52] shadow-[0_24px_60px_-24px_rgba(45,55,48,0.45)]"
          >
            <p className="text-[11px] uppercase tracking-[0.24em] text-[#8A9A86] mb-3">
              The world we believe in
            </p>
            <p className="font-serif-display text-2xl text-[#2D3730] leading-snug italic font-light">
              Where fathers are remembered for who they were, not just what they gave.
            </p>
          </motion.div>
        </div>

        {/* Right text block */}
        <div className="col-span-12 md:col-span-5 order-1 md:order-2">
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1 }}
          >
            <span className="font-serif-display text-[120px] md:text-[180px] leading-none text-[#8A9A86]/30 font-light block">
              02
            </span>
            <p className="text-[13px] md:text-sm uppercase tracking-[0.28em] text-[#C06E52] font-semibold -mt-4">
              The Vision
            </p>

            <h2
              data-testid="vision-heading"
              className="font-serif-display mt-10 text-[#2D3730] text-4xl sm:text-5xl lg:text-[60px] leading-[1.08] font-light tracking-tight"
            >
              A world where fathers are not just providers, but
              <span className="italic text-[#C06E52]"> emotionally present guides</span>{" "}
              in their children&rsquo;s lives.
            </h2>

            <p className="mt-10 text-[#5C665F] text-base md:text-lg leading-relaxed font-light max-w-[460px]">
              {`We see a generation of children who can navigate setbacks with resilience, express themselves with confidence, and approach life with emotional strength. Children who grow up knowing that emotional well-being is not something they discover by chance, but something that can be intentionally built.`}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
